import isEqualFromLodash from 'lodash/isEqual';

interface Args<P> {
  keys: P extends infer T ? Array<keyof T> : string[];
  source?: P extends infer T ? T : string[];
  target?: P extends infer T ? T : string[];
}

/**
 *
 * @param {Array<string>}keys 비교할 객체의 키값을 지정합니다.
 * @param source 현재의 props
 * @param target 변경된 props
 * @returns {boolean} true먄 렌더링을 하지않습니다.
 */
function isEqual<T extends Record<string, any>>({
  keys,
  source,
  target
}: Args<T>): boolean {
  if (!source || !target) return false;

  let result = false;
  let index = 0;

  while (true) {
    if (!isEqualFromLodash(source[keys[index]], target![keys[index]])) {
      result = false;
      break;
    }

    if (keys.length === index + 1) {
      result = true;
      break;
    }

    index++;
  }

  return result;
}

export default isEqual;
